import { useTranslation } from 'react-i18next';
import { Table } from 'lucide-react';

import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

export const EmptyTable = () => {
  const { t } = useTranslation();

  return (
    <Empty className="p-2!">
      <EmptyHeader className="flex-row items-center gap-2">
        <EmptyMedia
          variant="icon"
          className="m-0"
        >
          <Table className="text-muted-foreground" />
        </EmptyMedia>
        <EmptyTitle className="text-muted-foreground">
          {t('No Data Provided')}
        </EmptyTitle>
      </EmptyHeader>
    </Empty>
  );
};
